import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';
import React, { useEffect, useState } from 'react';
import { UNAVAILABLE_IMAGE_URL } from '../../constants/general';

interface CustomImageProps {
  src: string;
  alt: string | undefined;
  lazy: boolean;
  width?: string;
  height?: string;
}

export const CustomImage = ({
  src,
  alt = 'Unavailable image',
  lazy,
  width = 'auto',
  height = 'auto',
}: CustomImageProps) => {
  const [imageSrc, setImageSrc] = useState(src);
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = imageSrc;
    img.onload = () => {
      setImageSrc(src);
      setImageLoaded(true);
    };
    img.onerror = () => {
      setImageSrc(UNAVAILABLE_IMAGE_URL);
      setImageLoaded(true);
    };
  }, [src]);

  return (
    <>
      {imageLoaded ? (
        <img
          loading={lazy ? 'lazy' : undefined}
          src={imageSrc}
          alt={imageLoaded ? alt : ''}
          width={width}
          height={height}
        />
      ) : (
        <Skeleton disablePadding>
          <SkeletonBlock width={12} height={12} />
        </Skeleton>
      )}
    </>
  );
};
